import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import theme from '../../utils/theme';

interface Props {
  maxWidth?: number;
  isOverflowed: boolean;
}

const useStyles = makeStyles<Theme, Props>(theme => ({
  text: props => ({
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    width: '100%',
    maxWidth: props.maxWidth,
    cursor: props.isOverflowed ? 'pointer' : 'default',
  }),
  tooltip: {
    background: `${theme.palette.background.paper} !important`,
    color: `${theme.palette.text.primary} !important`,
    border: '1px solid rgba(0,0,0,0.12)',
    boxShadow: '0 6px 18px rgba(0,0,0,.12), 0 2px 6px rgba(0,0,0,.08)'
  },
}));

export default useStyles;
